module.exports = __webpack_public_path__ + "static/media/product-head.c20fce1e.png";